import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import { useModal } from '../../../Providers/ModalContext';
import Modal from '../../../Global/Modal';
import RichText from '../../../Global/RichText';
import ContactForm from '../../../Global/ContactForm';

import CloseIcon from '../../../../Images/icons/close-icon.png';
import KuterIcon from '../../../../Images/icons/kuter-icon.png';

import { Title_Modal_Consult } from '../../../../utils/EN/Modals/ModalConsult';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const KuterIconImg = styled.img`
  max-width: 96px;
  width: 100%;

  position: absolute;
  bottom: 0;
  right: 0;

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 56px;
  }
`;

const ModalConsultForm = () => {
  const { closeModal } = useModal();

  return (
    <>
      <Modal
        id="consult-form"
        bgColor={'rgba(0, 0, 0, 0.7)'}
        bgContent={'rgba(0, 0, 0, 1)'}
        padding={'68px 96px 20px 187px;'}
        contentMaxWidth={'1112px'}
        contentMaxHeight={'70%'}
      >
        <CloseContainer>
          <CloseButton
            onClick={closeModal}
            aria-label="Close modal"
            src={CloseIcon}
          />
        </CloseContainer>

        <RichText
          style={{ textAlign: 'center' }}
          dataText={Title_Modal_Consult}
        />
        <ContactForm valueForm="Contact" gtmEvent="consulta_enviada" />
        <KuterIconImg src={KuterIcon} alt="Kuter" />
      </Modal>
    </>
  );
};

export default ModalConsultForm;
